import {combineReducers} from "@reduxjs/toolkit";
import cryptoFragmentsReducer from "./crypto-fragments";

export default {
  e2ee: combineReducers({
    ...cryptoFragmentsReducer,
  }),
};
